/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://0w3pdpmkdj.execute-api.eu-central-1.amazonaws.com/punedemo",
            "region": "eu-central-1"
        },
        {
            "name": "SspBackendApi",
            "endpoint": "https://ili34nchia.execute-api.eu-central-1.amazonaws.com/punedemo",
            "region": "eu-central-1"
        },
        {
            "name": "SspExternalApi",
            "endpoint": "https://rn83zybrq6.execute-api.eu-central-1.amazonaws.com/punedemo",
            "region": "eu-central-1"
        },
        {
            "name": "bpmnGen",
            "endpoint": "https://g24v04g565.execute-api.eu-central-1.amazonaws.com/punedemo",
            "region": "eu-central-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-central-1:db037981-a29a-4bb5-9dae-abeac625f1a8",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_h8qoqP6te",
    "aws_user_pools_web_client_id": "6inmd89b17vorj603f9mjjpkoc",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "selfserviceportal-20240129105819-hostingbucket-punedemo",
    "aws_content_delivery_bucket_region": "eu-central-1",
    "aws_content_delivery_url": "https://d10lj3l11io1m.cloudfront.net",
    "aws_dynamodb_all_tables_region": "eu-central-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "SspUserInfo_punedemo",
            "region": "eu-central-1"
        }
    ]
};


export default awsmobile;
